import { Button } from "flowbite-react"
import moment from "moment"
import React from "react"

import DangerouslyHTMLTextPriview from "@components/elements/DangerouslyHTMLTextPriview"
import MonoImageGallery from "@components/elements/MonoImageGallery"
import RightArrow from "@icons/RightArrow"
import { phpToMoment } from "@mono/essentials/utils/Common"

const InfoStep = ({ handleNextStep, domainDetails, selectedProductData }) => {
  const images = selectedProductData?.mediaFiles?.map((image: any) => {
    return {
      original: `${image.public_url}`,
      thumbnail: `${image.public_url}`,
    }
  })

  return (
    <div>
      <div className={`md:grid md:grid-cols-2 xl:grid-cols-[720px_396px] lg:grid-cols-5`}>
        {" "}
        <div
          className={`md:border-neutral-200 md:border-r xl:col-span-1 lg:col-span-3 pb-5 px-0 xl:pr-8 sm:pr-6`}
        >
          <div className={"flex"}>
            <div className={"w-full"}>
              {selectedProductData &&
              selectedProductData?.mediaFiles &&
              selectedProductData?.mediaFiles?.length > 0 ? (
                <MonoImageGallery images={images || []} ContainerClassName={"w-full"} />
              ) : (
                <div
                  className={
                    "relative flex h-full min-h-[300px] max-[425px]:min-h-[220px] w-full cursor-pointer flex-row items-end rounded-lg bg-imagePlaceholderBackground bg-cover bg-center shadow-sm "
                  }
                >
                  <div
                    className={
                      "absolute left-1/2 top-1/2 h-11 w-[52px] -translate-x-1/2 -translate-y-1/2 transform bg-transparent bg-imagePlaceholder bg-contain bg-center bg-no-repeat"
                    }
                  />
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={"w-full border-b border-neutral-200 my-3"} />
            <div className={"mt-4 mb-3"}>
              <DangerouslyHTMLTextPriview
                content={selectedProductData?.description?.toString() ?? ""}
                className={"paragraph14Regular"}
              />
            </div>
          </div>
        </div>
        <div
          className={`xl:ml-8 sm:ml-6 md:sticky xl:col-span-1 lg:col-span-2 top-0 self-start`}
          id={"booking-container"}
        >
          <div className={`border border-neutral-450  rounded-md p-3 mb-4 shadow bg-white`}>
            <div className={"flex items-center justify-between"}>
              <div>
                <div className={"text15Semibold text-neutral-1000"}>
                  {selectedProductData?.name}
                </div>
                <div className={"flex flex-wrap flex-row items-center justify-start gap-3 mt-2"}>
                  {selectedProductData?.membership?.validity?.expiry_type === "fixed_date" ? (
                    <>
                      <p className={"text14Medium text-neutral-600"}>
                        <span className={"text-neutral-1000 text14Semibold"}>Start -</span>{" "}
                        {moment(
                          selectedProductData?.membership?.validity?.start_at,
                          "YYYY-MM-DD"
                        ).format(phpToMoment(domainDetails?.date_format || "Y-m-d"))}
                      </p>
                      <p className={"text14Medium text-neutral-600"}>
                        <span className={"text-neutral-1000 text14Semibold"}>End -</span>{" "}
                        {moment(
                          selectedProductData?.membership?.validity?.end_at,
                          "YYYY-MM-DD"
                        ).format(phpToMoment(domainDetails?.date_format || "Y-m-d"))}
                      </p>
                    </>
                  ) : selectedProductData?.membership?.validity?.expiry_type === "fixed_days" ? (
                    <p className={"text14Medium text-neutral-600"}>
                      <span className={"text-neutral-1000 text14Semibold"}>Expiry:</span>{" "}
                      {selectedProductData?.membership?.validity?.expiry_value}{" "}
                      {selectedProductData?.membership?.validity?.expiry_value > 1 ? "days" : "day"}{" "}
                      from the date of purchase.
                    </p>
                  ) : (
                    <p className={"text14Medium text-neutral-600"}>
                      <span className={"text-neutral-1000 text14Semibold"}>Expiry:</span> Never
                    </p>
                  )}
                </div>
              </div>
              <div className={"rounded-md bg-neutral-250 px-2 py-1"}>
                <span className={"text14Semibold text-neutral-800"}>
                  {selectedProductData?.membership?.price?.price_formatted ?? ""}
                </span>
              </div>
            </div>
          </div>

          <div className={""}>
            <Button
              color={"primary"}
              className={"w-full [&>span]:!text16Medium [&>span]:!py-[13px] !h-10"}
              onClick={handleNextStep}
            >
              Next
              <RightArrow className={"ml-2.5 text-whiteBlack-100"} height={20} width={20} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InfoStep
